export default function SelectForm({
  muscles,
  setSelectedIntensity,
  setSelectedMuscle,
  selectedIntensity,
  selectedMuscle,
}) {
  return (
    <form className="flex flex-col md:flex-row gap-4 justify-center items-center">
      <select
        className="px-10 py-2 rounded-2xl text-medium-black focus:outline-light-orange"
        value={selectedMuscle}
        onChange={(e) => setSelectedMuscle(e.target.value)}
      >
        {muscles.map((data) => {
          return (
            <option value={data} key={data}>
              {data}
            </option>
          );
        })}
      </select>

      <select
        className="px-10 py-2 rounded-2xl text-medium-black focus:outline-light-orange"
        value={selectedIntensity}
        onChange={(e) => setSelectedIntensity(e.target.value)}
      >
        <option value="Beginner">Beginner</option>
        <option value="Intermediate">Intermediate</option>
        <option value="Expert">Expert</option>
      </select>
    </form>
  );
}
